import { useRef, useEffect } from 'react';

export function usePrevious<T>(value: T, leading = true) {
	const ref = useRef(leading ? value : undefined);
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
}
